import transitionPage from "@/components/transitionPage/index";

export default {
  name: "register",
  metaInfo() {
    return {
      title: this.$t("seo.register.title"),
      meta: [{ name: "description", content: this.$t("seo.register.description") }]
    };
  },
  components: { transitionPage },
  props: [],
  data() {
    return {};
  },
  methods: {}
};
